import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/rechargeGift/lock.png'
import _imports_1 from '@/assets/rechargeGift/money_bag.png'


const _hoisted_1 = { class: "cardContainer" }
const _hoisted_2 = { class: "gridWrapper" }
const _hoisted_3 = {
  key: 0,
  class: "day1Card"
}
const _hoisted_4 = { class: "day1Content" }
const _hoisted_5 = { class: "gold-text" }
const _hoisted_6 = { class: "day1-body" }
const _hoisted_7 = { class: "day1-date" }
const _hoisted_8 = { class: "day1-amount" }
const _hoisted_9 = {
  key: 0,
  class: "availableTitle"
}
const _hoisted_10 = { class: "dayCardContent" }
const _hoisted_11 = { class: "day-num" }
const _hoisted_12 = { class: "dateText" }
const _hoisted_13 = { class: "dateText" }
const _hoisted_14 = { class: "accumulated-bar" }
const _hoisted_15 = { class: "accumulated-text" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "value gold-text2" }

import { dayFormat, formatCurrency, getDefaultRewards } from '@/utils/commonFunction';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'cashBackCard',
  props: {
    showClickButton: {
        type: Boolean,
    },
    availableValue: {
        type: Number,
        default: () => 0
    },
    givenValue: {
        type: Number,
        default: () => 0
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => getDefaultRewards()
    },
    createDate: {
        type: String,
        default: () => ""
    },
},
  emits: ['getClaim'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit

const clickOnButton = () => {
    emits('getClaim')
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.dayList && __props.dayList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('common.travel')) + " 1", 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(dayFormat)(__props.dayList[0].date, 0)), 1),
                _createElementVNode("div", _hoisted_8, "R$ " + _toDisplayString(_unref(formatCurrency)(__props.dayList[0].amount)), 1)
              ]),
              (props.showClickButton)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('activity.available')) + " " + _toDisplayString('R$ ' +
                        _unref(formatCurrency)(__props.availableValue)), 1))
                : _createCommentVNode("", true),
              (props.showClickButton)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "resgatar-btn",
                    onClick: clickOnButton
                  }, _toDisplayString(_ctx.$t('activity.click')), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayList?.slice(1), (i, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "dayCard smallCard"
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('common.travel')) + " " + _toDisplayString(index + 2), 1),
            _cache[0] || (_cache[0] = _createElementVNode("img", {
              src: _imports_0,
              width: "35%",
              style: {"padding":"4px 0 2px"}
            }, null, -1)),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(dayFormat)(i.date, 0)), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(formatCurrency)(i.amount)), 1)
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_van_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "24" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('activity.given')) + ":", 1),
                _createElementVNode("span", _hoisted_17, "R$ " + _toDisplayString(_unref(formatCurrency)(__props.givenValue)), 1)
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "money-bag-container" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  class: "money-bag-img"
                })
              ], -1))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})